import Flex from "../Flex"
import "./styles.css"

const Tag = ({ text, ...restProps }) => (
  <Flex className="custom-tag" {...restProps}>
    {text}
  </Flex>
)

export default Tag
